// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"J1-z","dimensionLabel":"K1-z","styleChooserControlWrapper":"L1-z","styleChooserControl":"M1-z","disabled":"N1-z","giftCard":"O1-z","styleChooserText":"P1-z"};